import useSWR from 'swr'
import fetcher from '../../utils/fetcher'
import {ResponseData} from './types'

interface Question {
  type: string
  serial: string
  title: string
  Aselect: string
  Bselect: string
  Cselect: string
}

export default function useFetchSurvey() {
  const res = useSWR<ResponseData<Question[]>>(
    '/psychology.php?a=list',
    fetcher.get
  )

  return res
}
